var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    [
      _c(
        "LoadingOverlay",
        {
          attrs: {
            loading: _vm.$apollo.queries.managers.loading,
            hasData: true,
          },
        },
        [
          _vm.isAdmin || _vm.hasAllResourceAccess
            ? _c("ContractorAboutForAdmin", {
                attrs: {
                  hasAllResourceAccess: _vm.hasAllResourceAccess,
                  isAdmin: _vm.isAdmin,
                  adminUserId: _vm.currentUser.id,
                  company: _vm.company,
                  contractorUserId: _vm.id,
                },
              })
            : _c("ContractorAboutForManager", {
                attrs: {
                  isAdmin: _vm.isAdmin,
                  managerUserId: _vm.currentUser.id,
                  company: _vm.company,
                  contractorUserId: _vm.id,
                  currentUserManagerId: _vm.currentUserManagerId,
                },
              }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }